import React from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';

export const VanillaLink = props => <a {...props} />; // eslint-disable-line

let implementation = data =>
  data.to.startsWith('http') ? <VanillaLink href={data.to} {...data} /> : <GatsbyLink {...data} />;

export function setImplementation(link) {
  implementation = link;
}

const Link = props => implementation(props);
Link.propTypes = {
  to: PropTypes.string.isRequired,
};
export default Link;



// WEBPACK FOOTER //
// ./src/components/common/link.jsx